import getPageOffset from './getPageOffset';

const composePaginationLinkTo = (pageNumber, limit, searchParams) => {
  const linkSearchParams = new URLSearchParams(searchParams.toString());
  const offset = getPageOffset(pageNumber, limit);

  linkSearchParams.set('start_rank', String(offset));
  let pathname = window.location.pathname;
  return {
    pathname: pathname,
    search: `?${linkSearchParams.toString()}`,
  };
};

export default composePaginationLinkTo;
